$(function() {
  let songsData = [];
  let songIndex = 0;

  function addSong(name, artist, album, filename, cover_art_url) {

    if (!filename.includes("https")) {
      filename = "https:" + filename;
    } 
    
    songsData.push({
      "name": name,
      "artist": artist,
      "album": album,
      "url": filename,
      "cover_art_url": "https:" + cover_art_url
    });
  }

  $(".amplitude-player-wrapper").each(function(){
    const id_index = songIndex + 1;
    const name = $(this).data("name");
    const artist = $(this).data("artist");
    const album = $(this).data("album");
    const cover_art_url = $(this).data("cover_art_url");
    const filename = $(this).data("filename");
  
    $(this).find(".amplitude-current-minutes").attr('data-amplitude-song-index', songIndex);
    $(this).find(".amplitude-current-seconds").attr('data-amplitude-song-index', songIndex);
    $(this).find(".amplitude-duration-minutes").attr('data-amplitude-song-index', songIndex);
    $(this).find(".amplitude-duration-seconds").attr('data-amplitude-song-index', songIndex);
    $(this).find(".amplitude-song-played-progress").attr('data-amplitude-song-index', songIndex).attr('id', `song-played-progress-${id_index}`);
    $(this).find(".amplitude-play-pause").attr('data-amplitude-song-index', songIndex);
    // $(this).find(".amplitude-wave-form").attr('data-amplitude-song-index', songIndex);
    
    addSong(name, artist, album, filename, cover_art_url);

    document.getElementById(`song-played-progress-${id_index}`).addEventListener('click', function( e ){
    if( Amplitude.getActiveIndex() == id_index - 1 ){
      var offset = this.getBoundingClientRect();
      var x = e.pageX - offset.left;
      var playedPercentage = ( parseFloat( x ) / parseFloat( this.offsetWidth) ) * 100
        Amplitude.setSongPlayedPercentage( playedPercentage );
      }
      
    });

    const progressElement = document.getElementById(`song-played-progress-${id_index}`);
    const sibling = progressElement.previousElementSibling;
    
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'value') {
          // The 'value' attribute has changed
          const newValue = progressElement.getAttribute('value') * 100;
          sibling.style.clipPath = `polygon(0% 0%, ${newValue}% 0%, ${newValue}% 100%, 0% 100%)`;
        }
      }
    });
    
    observer.observe(progressElement, { attributes: true });

    songIndex++;
  })

  // 32: 'play_pause'
  Amplitude.init({
    "bindings": {
      37: 'prev',
      39: 'next'
    },
    "songs": songsData,
    "waveforms": {
      "sample_rate": 40
    }
  });

});

$(function(){
    const renderedHeight = $(".product-info .variant-picker__option-values").innerHeight();
    const actualHeight = $(".product-info .variant-picker__option-values")[0]?.scrollHeight;
  
    if (renderedHeight < 320 || renderedHeight > actualHeight) {
      $(".product-info .variant-picker__option-values").css({
        "overflow": "visible",
        "clip-path": "unset"
      });
      $("#toggle-button").hide();
      return;
    }

   $("#toggle-button").click(function() {

    $(".product-info .variant-picker__option-values").toggleClass("expanded");
    if ($(".product-info .variant-picker__option-values").hasClass("expanded")) {
      $("#toggle-button").text("Less");
    } else {
      $("#toggle-button").text("More");
    }
  });
});